module.exports = __webpack_public_path__ + "img/f22bf49.jpg";